import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Card, CardContent, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  padding: '3.5rem 1rem 0 1rem',
  flexGrow: 1,
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '2rem',
  justifyContent: 'flex-start',
}));

export const CardStyled = styled(Card)(() => ({
  width: '100%',
  color: 'white',
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const CardContentStyled = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingleft: '1.5rem',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    alignItems: 'start',
  },
}));

export const AlignMiniButton = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '3rem',
  },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: '5rem',
  },
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '1rem',
}));

export const AlignMobileButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  position: 'fixed',
  right: '1rem',
  bottom: '3.2rem',
  zIndex: 999,
}));

export const IconColorDownload = styled(FileDownloadOutlinedIcon)(() => ({
  color: theme.palette.primary.dark,
}));

export const IconColorUpload = styled(FileUploadOutlinedIcon)(() => ({
  color: theme.palette.primary.dark,
}));

export const AlignButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '2rem',
}));
